import type { GridRowId, GridRowSelectionModel } from "@mui/x-data-grid";

/**
 * The row IDS a MUI selection model represents, given the grid's current rows.
 *
 * This is the emit contract for QubesGrid's onRowSelection under multiSelect, and
 * it is deliberately IDS — never row objects. Every consumer resolves the result
 * as an id (ViewManager.selectedRow via currentRows.get(String(id)); the page-DSL
 * onDependencySelectionChanged via dependencyApi.getRow(id)). An earlier version
 * mapped these ids back to row objects before emitting, which silently broke
 * multiSelect-driven dependent-view filtering.
 * BUG-20260905-qubes-grid-multiselect-emits-row-objects.
 */
export function selectedRowIds(
  selectionModel: GridRowSelectionModel,
  currentRowIds: Iterable<GridRowId>,
): GridRowId[] {
  return selectionModel.type === "exclude"
    ? [...currentRowIds].filter((id) => !selectionModel.ids.has(id))
    : [...selectionModel.ids].map((id) => String(id));
}
